"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Risk API
 * Risk Service API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetImportanceToJSON = exports.AssetImportanceFromJSONTyped = exports.AssetImportanceFromJSON = exports.AssetImportance = void 0;
/**
 *
 * @export
 */
exports.AssetImportance = {
    Unassigned: 'unassigned',
    None: 'none',
    Low: 'low',
    Medium: 'medium',
    High: 'high',
    Critical: 'critical'
};
function AssetImportanceFromJSON(json) {
    return AssetImportanceFromJSONTyped(json, false);
}
exports.AssetImportanceFromJSON = AssetImportanceFromJSON;
function AssetImportanceFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AssetImportanceFromJSONTyped = AssetImportanceFromJSONTyped;
function AssetImportanceToJSON(value) {
    return value;
}
exports.AssetImportanceToJSON = AssetImportanceToJSON;
